import { Icon, Text } from '@genial/components';
import { Color, Spacing, Typography } from '@genial/design-tokens';
import { IconographyTypes } from '@genial/icons';
import { Utils } from '@genial/utils';
import React from 'react';
import { Pressable, StyleSheet, View } from 'react-native';

export interface ActionButtonProps {
  label: string;
  icon: IconographyTypes.Option;
  onPress?: () => void;
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  content: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: Utils.Token.ToInt(Spacing, 'stack.nano'),
  },
});

export const ActionButton: React.FC<ActionButtonProps> = ({ onPress, icon, label }) => {
  return (
    <Pressable onPress={onPress} style={styles.container}>
      <View style={styles.content}>
        <Icon name={icon} size="xxs" color={Color['neutral.tertiary']} />
        <Text fontSize={Typography['fontsize.md']}>{label}</Text>
      </View>
      <Icon name="ChevronRight" size="xs" />
    </Pressable>
  );
};
